import React from 'react';
import { TaskBoard as TaskBoardComponent } from '../../components/Tasks';
import Layout from '../../components/Layout/Layout';

const TaskBoard = () => {
  return (
    <Layout>
      <TaskBoardComponent />
    </Layout>
  );
};

export default TaskBoard;

